<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >

    <template #layoutContent>
      <Loader :is-loading="isLoading">
        <div class="row" style="min-height: 75vh">
          <div class="col-md-4 h-100">
            <Card :title="$t('access.doorList')" containerClass="mb-5" style="min-height: 70vh">
              <template #cardToolbar>
                <div class="d-flex align-items-center">
                  <div class="dropdown">
                    <a class="btn btn-primary " href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="bi bi-plus fs-2"></i>
                      {{ $t('button.add') }}
                    </a>

                    <ul class="dropdown-menu">
                      <li><a v-if="$can(abilities.CAN_CREATE_PERIMETER)"  class="dropdown-item px-3" href="#"  @click.prevent="toggleModal('#create_perimeter_modal')" >
                         <span class="">
                          <span class="me-4 fs-3 text-hover-primary">
                            <svg  width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <mask id="mask0_4995_3124322" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="17">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.50024 1L21.0001 6V16H7.50024V1Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M7.49992 1L1 6V16H7.49992" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.4997 16V10L11.9998 8.5V16" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M21.0001 16H7.50024" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </mask>
                              <g mask="url(#mask0_4995_3124322)">
                                <path d="M-1 -6H22.9997V18H-1V-6Z" fill="currentColor"/>
                                <path d="M-1 -6H22.9997V18H-1V-6Z" fill="black" fill-opacity="0.2"/>
                              </g>
                            </svg>
                          </span>
                          <span> {{ $t('access.newPerimeter') }} </span>
                        </span>
                      </a></li>
                      <li>
                        <a class="dropdown-item px-3"v-if="$can(abilities.CAN_CREATE_DOOR)"  href="#" @click.prevent="toggleModal('#create_door_modal')">
                          <span class="">
                          <span class="me-4 fs-3 text-hover-primary">
                            <svg width="22" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M0.961921 17C0.819921 17 0.700921 16.952 0.604921 16.856C0.508921 16.76 0.461254 16.641 0.461921 16.499C0.462588 16.357 0.510254 16.2383 0.604921 16.143C0.699588 16.0477 0.818588 16 0.961921 16H1.99992V2.116C1.99992 1.67133 2.15825 1.291 2.47492 0.975C2.79159 0.659 3.17159 0.500667 3.61492 0.5H12.3849C12.8289 0.5 13.2089 0.658333 13.5249 0.975C13.8409 1.29167 13.9993 1.67167 13.9999 2.115V16H15.0389C15.1803 16 15.2989 16.048 15.3949 16.144C15.4909 16.24 15.5386 16.359 15.5379 16.501C15.5373 16.643 15.4896 16.7617 15.3949 16.857C15.3003 16.9523 15.1813 17 15.0379 17H0.961921ZM12.9999 16V2.116C12.9999 1.936 12.9423 1.78833 12.8269 1.673C12.7116 1.55767 12.5643 1.5 12.3849 1.5H8.84592V1.016C9.46392 1.08467 9.97725 1.35 10.3859 1.812C10.7946 2.274 10.9993 2.81233 10.9999 3.427V14.739C10.9999 15.1417 10.8609 15.4993 10.5829 15.812C10.3049 16.1247 9.96259 16.3033 9.55592 16.348V16H12.9999ZM7.00992 9.77C7.22259 9.77 7.40225 9.69333 7.54892 9.54C7.69559 9.38667 7.76892 9.20333 7.76892 8.99C7.76892 8.77667 7.69525 8.597 7.54792 8.451C7.40059 8.305 7.21792 8.23167 6.99992 8.231C6.79325 8.231 6.61325 8.30467 6.45992 8.452C6.30659 8.59933 6.22992 8.782 6.22992 9C6.22992 9.20667 6.30659 9.38667 6.45992 9.54C6.61325 9.69333 6.79659 9.77 7.00992 9.77Z" fill="currentColor"/>
                              <path d="M0.961921 17C0.819921 17 0.700921 16.952 0.604921 16.856C0.508921 16.76 0.461254 16.641 0.461921 16.499C0.462588 16.357 0.510254 16.2383 0.604921 16.143C0.699588 16.0477 0.818588 16 0.961921 16H1.99992V2.116C1.99992 1.67133 2.15825 1.291 2.47492 0.975C2.79159 0.659 3.17159 0.500667 3.61492 0.5H12.3849C12.8289 0.5 13.2089 0.658333 13.5249 0.975C13.8409 1.29167 13.9993 1.67167 13.9999 2.115V16H15.0389C15.1803 16 15.2989 16.048 15.3949 16.144C15.4909 16.24 15.5386 16.359 15.5379 16.501C15.5373 16.643 15.4896 16.7617 15.3949 16.857C15.3003 16.9523 15.1813 17 15.0379 17H0.961921ZM12.9999 16V2.116C12.9999 1.936 12.9423 1.78833 12.8269 1.673C12.7116 1.55767 12.5643 1.5 12.3849 1.5H8.84592V1.016C9.46392 1.08467 9.97725 1.35 10.3859 1.812C10.7946 2.274 10.9993 2.81233 10.9999 3.427V14.739C10.9999 15.1417 10.8609 15.4993 10.5829 15.812C10.3049 16.1247 9.96259 16.3033 9.55592 16.348V16H12.9999ZM7.00992 9.77C7.22259 9.77 7.40225 9.69333 7.54892 9.54C7.69559 9.38667 7.76892 9.20333 7.76892 8.99C7.76892 8.77667 7.69525 8.597 7.54792 8.451C7.40059 8.305 7.21792 8.23167 6.99992 8.231C6.79325 8.231 6.61325 8.30467 6.45992 8.452C6.30659 8.59933 6.22992 8.782 6.22992 9C6.22992 9.20667 6.30659 9.38667 6.45992 9.54C6.61325 9.69333 6.79659 9.77 7.00992 9.77Z" fill="black" fill-opacity="0.2"/>
                            </svg>
                          </span>
                          <span> {{ $t('access.newDoor') }} </span>
                        </span>
                      </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </template>
              <div v-if="formatedPerimeters.length" class="card-body p-0 px-2">
                <DoorsTree
                    :perimeters="formatedPerimeters"
                    :userAssignSonote="userAssignSonote"
                    v-model="currentSelected"
                    @reload="reloadTreeData"
                />
              </div>
              <div v-else  class="card-body mt-5 p-0">
                <div class="d-flex align-items-center justify-content-center scroll-y p-2" style="min-height: 65vh">
                  <div class="mb-10 mt-20 text-center">
                    <div class="fs-2 fw-bold text-gray-800 text-center mb-13">
                      {{ $t('access.noDoorsOrPerimetersFound') }}
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
          <div v-if="currentSelected && currentPerimeter" class="col-md-8 h-100">
            <PerimeterDetail :perimeter="currentPerimeter" />
          </div>
          <div v-else class="col-md-8 h-100">
            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center justify-content-center scroll-y p-2" style="min-height: 65vh">
                  <div class="text-center">
                    <div class="fs-2 fw-bold text-gray-800 text-center mb-13">
                      {{ $t('access.noDoorsOrPerimetersSelected') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Loader>
    </template>
  </SubLayout>
  <CreateDoors @load="loadData" id="create_door_modal" />
  <CreatePerimeter @load="loadData" id="create_perimeter_modal" />
</template>

<script setup>
import {computed, onMounted, ref, watch} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useStore} from "vuex";
import {useLocales} from "@/composables/locales";
import {useHasAbility} from "@/composables/hasAbility";
import Card from "@/Modules/CRM/components/Card";
import Button from "@/components/Button.vue";
import DoorsTree from "@/Modules/Access/views/Config/components/DoorsTree.vue";
import CreateDoors from "@/Modules/Access/components/Modals/Doors/CreateOrUpdateDoors.vue";
import CreatePerimeter from "@/Modules/Access/components/Modals/Perimeters/CreateOrUpdatePerimeter.vue";
import Loader from "@/components/Loader.vue";
import PerimeterDetail from "@/Modules/Access/views/Config/components/PerimeterDetail.vue";
import abilities from "@/composables/abilities";
const store = useStore()
const { can } = useHasAbility()
const {locale, datatableLocaleUrl} = useLocales()


const title = ref("menu.access.title")
const breadcrumbs = ref([
  {
    name: 'access.title',
    route: 'access-configs'
  }
])
const isLoading = ref(true)
const currentSelected = ref('')
const table = ref()
const query = ref({
  status: '',
})

const perimeters = computed(() => store.getters['perimeters/getMainPerimeters'])


const userAssignSonote = computed(() => store.getters['perimeters/getUserAssignDoorSonote']);

const formatedPerimeters = computed(() => {
  if(!perimeters.value.length) return []
  return formatTreeData(perimeters.value)
})
const currentPerimeter = computed(() => {
  if(!currentSelected.value) return null
  return findNodeById(formatedPerimeters.value, currentSelected.value)
})

watch(() => locale.value, (value) => {
}, { deep: true })

function toggleModal(modalId) {
  $(modalId).modal('toggle')
}

function formatTreeData(data, isStat = true) {
  let tree = []


  data.forEach(perimeter => {
    let node = {
      id: perimeter.id,
      name: perimeter.name,
      accessMethods: perimeter.accessMethods,
      children: [],
      isStat,
      isDoor: !perimeter?.doors && !perimeter?.children
    }

    if (perimeter.children && perimeter.children?.length) {
      const formattedChildren = formatTreeData(perimeter.children, false)
      node.children.push(...formattedChildren)
    }

    if (perimeter.doors && perimeter.doors?.length) {
      const formattedDoors = formatTreeData(perimeter.doors, false)
      node.children.push(...formattedDoors)
    }

    tree.push(node)
  })

  return tree
}

function findNodeById(tree, id) {
  for (const node of tree) {
    if (node.id === id) {
      return node
    }

    if (node.children && node.children.length) {
      const found = findNodeById(node.children, id)
      if (found) {
        return found
      }
    }
  }

  return null
}

function loadData() {
  Promise.all([
      store.dispatch('perimeters/loadMainPerimeters'),
      store.dispatch("perimeters/loadPerimeters"),
      store.dispatch('methods/loadMethods'),
      store.dispatch('access/getDayCollection')
  ]).finally(() => isLoading.value = false);
}

function reloadTreeData() {
  store.dispatch('perimeters/loadMainPerimeters')
  store.dispatch("perimeters/loadPerimeters")
}

onMounted( () => {
  loadData()
  store.dispatch('access/getDayCollection')
  store.dispatch('perimeters/loadUserAssignDoorSonote')
})
</script>

